// Mock data for PROTEGO Law Firm website

export const mockData = {
  // Season detection - will be replaced with real logic
  currentSeason: 'winter',
  
  // Hero images by season
  seasonImages: {
    winter: 'https://images.unsplash.com/photo-1514496959998-c01c40915c5f',
    spring: 'https://images.unsplash.com/photo-1601281426795-9fedf41df8d1',
    summer: 'https://images.unsplash.com/photo-1612441804231-77a36b284856',
    autumn: 'https://images.unsplash.com/photo-1604223190546-a43e4c7f29d7'
  },
  
  // Company info
  company: {
    name: 'АДВОКАТСЬКЕ ОБ\'ЄДНАННЯ «ПРОТЕГО»',
    shortName: 'ПРОТЕГО',
    tagline: 'Захист. Довіра. Результат.',
    edrpou: '45858626',
    address: '49044, м. Дніпро, вул. Вернадського Володимира, буд. 27, офіс 17',
    phone: '+38 (067) 077-07-60',
    email: 'aoprotego@gmail.com',
    workingHours: 'Понеділок - П\'ятниця: 9:00 - 18:00'
  },
  
  // About section
  about: {
    title: 'Про нас',
    description: 'Адвокатське об\'єднання «ПРОТЕГО» — команда професіоналів з багаторічним досвідом у галузі права. Ми надаємо комплексні юридичні послуги для бізнесу та приватних осіб. Наша діяльність базується на принципах конфіденційності, відповідальності та чіткого дотримання законодавства. Кожен клієнт отримує індивідуальний підхід та юридичний супровід найвищого рівня. Ми прагнемо до максимального захисту інтересів наших клієнтів у будь-яких правових питаннях.'
  },
  
  // Practice areas
  practiceAreas: [
    {
      id: 1,
      title: 'Корпоративне право',
      description: 'Юридичний супровід створення, реорганізації та ліквідації підприємств. Консультування з питань корпоративного управління та захисту прав акціонерів.'
    },
    {
      id: 2,
      title: 'Судові спори',
      description: 'Представництво інтересів клієнтів у судах усіх інстанцій. Захист прав у цивільних, господарських та адміністративних справах.'
    },
    {
      id: 3,
      title: 'Податкове право',
      description: 'Консультування з питань оподаткування та податкового планування. Супровід податкових перевірок та вирішення податкових спорів.'
    },
    {
      id: 4,
      title: 'Господарські справи',
      description: 'Підготовка та супровід господарських договорів. Вирішення комерційних спорів та захист ділової репутації.'
    },
    {
      id: 5,
      title: 'Правовий супровід бізнесу',
      description: 'Комплексне юридичне обслуговування підприємств. Абонентське правове супроводження та консультування з усіх напрямків діяльності.'
    }
  ],
  
  // Managing Partner
  managingPartner: {
    title: 'Керуючий партнер',
    name: 'Якимець Ярослав Костянтинович',
    bio: 'Керуючий партнер адвокатського об\'єднання «ПРОТЕГО» з понад 15 років досвіду у сфері права. Спеціалізується на корпоративному праві та судових спорах високої складності. Під його керівництвом команда здійснила успішний супровід понад 500 справ. Відповідальний підхід до кожної справи та дотримання найвищих етичних стандартів — основа його професійної діяльності. Забезпечує стратегічний розвиток фірми та особисто керує найбільш складними проектами.'
  },
  
  // Values
  values: [
    {
      id: 1,
      title: 'Конфіденційність',
      description: 'Абсолютна гарантія збереження комерційної та особистої таємниці клієнтів на всіх етапах співпраці.'
    },
    {
      id: 2,
      title: 'Відповідальність',
      description: 'Повна відповідальність за результат та дотримання узгоджених термінів виконання доручень.'
    },
    {
      id: 3,
      title: 'Системний підхід',
      description: 'Комплексний аналіз правової ситуації з урахуванням всіх можливих ризиків та наслідків.'
    },
    {
      id: 4,
      title: 'Захист інтересів клієнта',
      description: 'Беззастережний пріоритет інтересів клієнта в межах діючого законодавства та професійної етики.'
    }
  ],
  
  // Mock legal news - will be replaced with AI-generated content
  legalNews: [
    {
      id: 1,
      title: 'Зміни в податковому законодавстві 2025',
      date: '2025-01-15',
      summary: 'Верховна Рада України прийняла поправки до Податкового кодексу, що стосуються оподаткування малого та середнього бізнесу. Зміни набудуть чинності з 1 березня 2025 року.'
    },
    {
      id: 2,
      title: 'Нові правила корпоративного управління',
      date: '2025-01-10',
      summary: 'НКЦПФР затвердила оновлені вимоги до корпоративного управління публічних акціонерних товариств. Компанії мають привести свої статути у відповідність до кінця 2025 року.'
    },
    {
      id: 3,
      title: 'Реформа господарського судочинства',
      date: '2025-01-05',
      summary: 'Введено електронний документообіг у господарських судах всіх інстанцій. Система «Електронний суд» стає обов\'язковою для всіх учасників процесу.'
    }
  ]
};
